<template>

    <section class="products">
        <div class="container">

            <div class="box-title">
                <h1>{{category.nombre}}</h1>
                <ul class="subcategorias" >

                    <li v-if="((category.childs) && (category.childs.length>1))">
                      <a href="" @click.prevent="changeCategory(defaultCategory)">Todos</a>
                    </li>

                    <li v-for="child in category.childs">
                        <a href="" @click.prevent="changeCategory(child.id)">{{child.nombre}}</a>
                    </li>
                </ul>
            </div>

            <div class="row">

              <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" v-for="product in products" :key="product.id" v-if="products.length>0">
                <product-box :product="product"></product-box>
              </div>

              <infinite-loading @infinite="infiniteScrollRest" spinner="waveDots">

                <div slot="no-more"></div>
                <div slot="no-results"></div>

              </infinite-loading>


            </div>

        </div>
    </section>

</template>

<script>

    import ProductBox from "@/components/ProductBox";
    import Api from '@/Api'

    export default {
        name: "CategoryPage",
        components: {ProductBox},
        data () {
            return {
                category:{},
                products: [],
                defaultCategory:0,
                categoryId: 0,
                currentPage:1,
                totalPage:0,
            }
        },
        methods:{
          changeCategory(category){

            this.products = [];
            this.currentPage = 1;
            this.categoryId = category;
            this.infiniteScrollRest();
          },
          infiniteScrollRest ($state) {


            Api().get('?func=getProductosFromCategory&id='+this.categoryId+'&page='+this.currentPage).then(data=>{

              if (data.data.success){

                data.data.payload.products.forEach(value => {
                  this.products.push(value);
                });

                if(data.data.payload.total_pages===0){
                  $state.complete();
                }
                else if (this.currentPage==data.data.payload.total_pages){
                  $state.complete();
                }else{
                  this.currentPage = data.data.payload.current_page + 1;
                  $state.loaded();
                }




              }else{
                this.products = [];
              }

            }).catch(err=>{

            });

          },
        },
        mounted(){


            $('body').removeClass();
            this.categoryId = this.$route.params.id;
            this.defaultCategory = this.$route.params.id;

             Api().get('?func=getCategoryData&id='+this.categoryId).then(data=>{

              if (data.data.success)
              {
                this.category = data.data.payload.category;
              }

            }).catch(err=>{

            });
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CategoryPage.vue